function Map() {
    return (
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3156.644981988321!2d145.2070311758802!3d-37.704535872003184!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad636b9544d8653%3A0x4a3c774abb0ee366!2sInglewood%20Estate!5e0!3m2!1sen!2sus!4v1718405689331!5m2!1sen!2sus"
          width="100%"
          height="100%"
          allowFullScreen
          style={{ border: 'none' }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
    )
}

export default Map
